export const colors = {
    LandingPage_Background: '#FFFFFF',
    LandingPage_Description: '#373737',
    Button_Secondary: '#D1A219',
    Header_Content: '#000000',
    Black: '#000000',
    Header_Text: "#FFFFFF",
    Table_Header: '#BFCACD',
    Action_Button_Back: '#0A6AAD',
    ALERT_BUTTON_GOTO_COLOR: "#c6e2f6",
    HEADER: '#2a383b',
    BORDER_BACKGROUND: "#d6d6d6",
    CAR_BOX_EVEN: '#DEDFD5',
    CAR_BOX_ODD: '#f5bf19',
    Header: '#383C3D',

    Primary: '#181f2a'
}